import React from "react";
import { useAppSelector, useAppDispatch } from "../../hooks";
import NewCharacter from "../Character/NewCharacter";
import CharacterMessage from "../Character/CharacterMessage";
import PreviewBook from "../Character/PreviewBook";
import PreviewCharacter from "../Character/PreviewCharacter";
import Address from "../../components/Order/Address";
import { handleNext } from "../../redux/slices/stepSlice";
import GiftMailThanks from "./GiftMailThanks";
import axios from "axios";

const Gift = ({ data }) => {
  const dataPage = useAppSelector((state) => state.pageData);
  const currentUser = dataPage?.data?.data?.current_user || {};
  const step = useAppSelector((state) => state.step);
  const character = useAppSelector((state) => state.character);
  const page = step.page;
  const gift = true;
  const dispatch = useAppDispatch()
  const handleNextPage = () => {
    window.onbeforeunload = () => {};
    dispatch(handleNext());
  };

  window.onbeforeunload = () => {
    return ''
  };

  const handleAddressNext = async (values: any) => {
    values.name = values?.name.replace(/\s+/g,' ').trim();
    values.furigana = values?.furigana.replace(/\s+/g,' ').trim();
    values.address2 = values?.address2.replace(/\s+/g,' ').trim();
    values.address3 = values?.address3?.replace(/\s+/g, ' ').trim();

    const formData = new FormData();
    formData.append(
      "authenticity_token",
      dataPage.data?.data?.data?.form_authenticity_token
    );
    formData.append("id", dataPage.data?.data?.data?.id);
    formData.append("character", JSON.stringify(character));
    formData.append("address", JSON.stringify(values));
    formData.append("selectedFile", character.infor.image.file);
    try {
      const response = await axios({
        method: "post",
        url: "/gifts/gift_complete",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status == 200) {
        console.log("success");
        dispatch(handleNext());
      } else {
        window.onbeforeunload = () => {};
        window.location.href = `/errors/expired_gift`;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const conditionalComponent = () => {
    switch (page) {
      case 0:
        return <NewCharacter data={data} />;
      case 1:
        return <CharacterMessage />;
      case 2:
        return <PreviewBook />;
      case 3:
        return <PreviewCharacter gift={gift} handleGift={handleNextPage} />;
      case 4:
        return <Address gift={gift} handleNextPage={handleAddressNext} currentUser={currentUser} />;
      case 5:
        return <GiftMailThanks />;
      default:
        return <NewCharacter data={data} />;
    }
  };

  return <>{conditionalComponent()}</>;
};

export default Gift;
